var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"broadcast-section"},[(_vm.broadcast)?_c('WizardForm',{attrs:{"page-type":"update","broadcast":_vm.broadcast},on:{"broadcast-changed":_vm.broadcastChanged}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }